// extracted by mini-css-extract-plugin
var _1 = "faq_answer__gousy";
var _2 = "faq_answerwrapper__impbt";
var _3 = "#4c4c4c";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "faq_divider__f9lqc";
var _8 = "#434343";
var _9 = "faq_hidebg__nt52v";
var _a = "faq_list__zhze9";
var _b = "79px";
var _c = "110px";
var _d = "72px";
var _e = "665px";
var _f = "faq_open__h+lqi";
var _10 = "faq_question__vuvuu";
var _11 = "teal";
var _12 = "faq_text__ayitg";
var _13 = "2";
var _14 = "#cdd3dc";
var _15 = "faq_wrapper__s4wx4";
export { _1 as "answer", _2 as "answerWrapper", _3 as "body", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "divider", _8 as "headline", _9 as "hideBg", _a as "list", _b as "menuHeight", _c as "menuHeightLarge", _d as "menuHeightMobile", _e as "modalMobileWidth", _f as "open", _10 as "question", _11 as "teal", _12 as "text", _13 as "timelineStrokeWidth", _14 as "timelineTrackColor", _15 as "wrapper" }
